/* global globalThis */
import React, { useEffect, useState } from 'react';
import './ChangePassword.scss';
import { LanguageSelect } from "../../pages/LanguageSelect";
import { useDispatch, useSelector } from 'react-redux';
import { useNetworkStatus, useTranslations } from 'examsbook-react-sdk/custom-hooks';
import { Box, Button, Grid, Icon, Input, InputLabel, Link } from '@material-ui/core';
import i18n from 'examsbook-react-sdk/translations';
import { changePasswordNewUser, emailChangePasswordNewUser } from 'examsbook-react-sdk/actions/getUser';
import { Link as RouterLink, useHistory, useLocation } from 'react-router-dom';
import LearnifyIcon from "../../assets/images/LearnifyLogoDark.png"
import { getSettingsAction, setSubdomain } from 'examsbook-react-sdk/actions/getSettingsAction';
import { ColorsConstant } from '../../constants/colorConstant';

const INPUT_TYPE_PASSWORD = 'password';
const INPUT_TYPE_TEXT = 'text';

const ChangePassword = () => {
  const [settingsData, setSettingsData] = useState([]);
  const [bgColor, setBgColor] = useState('');
  const [textColor, setTextColor] = useState('');
  const [dynamicLogo, setDynamicLogo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [formValues, setFormValues] = useState({ newPassword: "", confirmPassword: "" });
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const isOnline = useNetworkStatus();
  const [subDomainName, setSubDomainName] = useState('');
  const language = useSelector((state) => state.getLanguaggeReducer.lang) || "en";

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language]);

  const dispatch = useDispatch();
  const t = useTranslations();
  const history = useHistory();
  const location = useLocation();

  let subdomain = useSelector(state => state?.subdomainReducer?.subdomain) || subDomainName;

  useEffect(() => {
    const dynamicLogos = settingsData?.data?.[0]?.branding?.logos?.webAndAppLogo?.imagePath;
    setDynamicLogo(dynamicLogos || LearnifyIcon);
    setBgColor(settingsData?.data?.[0] ? settingsData?.data?.[0]?.branding?.backgroundAndTextTheme?.primaryBackgroundColor : ColorsConstant.defaultBlue);
    setTextColor(settingsData?.data?.[0] ? settingsData?.data?.[0]?.branding?.backgroundAndTextTheme?.primaryTextColor : ColorsConstant.white);
  }, [isLoading, settingsData]);

  useEffect(() => {
    getSubdomain();
  }, []);

  useEffect(() => {
    if (subdomain && subdomain !== null) {
      getSettingsApiData();
    }
  }, [subdomain]);

  const getSettingsApiData = async () => {
    try {
      await dispatch(getSettingsAction(subdomain)).then((res) => {
        setSettingsData(res?.data);
        setIsLoading(true);
      });
    } catch (error) {
      console.log("Error -", error.message);
    }
  };

  const togglePasswordVisibility = (inputId, iconId) => {
    const inputElement = document.getElementById(inputId);
    const icon = document.getElementById(iconId);

    if (!inputElement || !icon) {
      return;
    }

    const isMasked = inputElement.type === INPUT_TYPE_PASSWORD;
    inputElement.type = isMasked ? INPUT_TYPE_TEXT : INPUT_TYPE_PASSWORD;
    icon.classList.replace(
      isMasked ? 'fa-eye-slash' : 'fa-eye',
      isMasked ? 'fa-eye' : 'fa-eye-slash'
    );
  };

  const preventSpaceKey = (event) => {
    if (event.key === " ") {
      event.preventDefault();
    }
  };


  const getSubdomain = () => {
    const host = globalThis.location.host;
    const domainParts = host.split('.');
    if (process.env.REACT_APP_TENANT_DOMAIN) {
      setSubDomainName(process.env.REACT_APP_TENANT_DOMAIN);
      dispatch(setSubdomain(process.env.REACT_APP_TENANT_DOMAIN));
    }
    else if (domainParts.length > 3) {
      const domainName = domainParts[0];
      setSubDomainName(domainName);
      dispatch(setSubdomain(domainName));
    }
  };

  const handleSetPassword = async (e) => {
    e.preventDefault();
    const { confirmPassword, newPassword } = formValues;
    const { password, ...rest } = location?.state ?? {}
    const email = new URLSearchParams(globalThis.location.search).get('email') || "";

    const changePasswordData = {
      ...rest,
      email: email || rest.email,
      oldPassword: password || location?.state?.enteredOtp,
      subdomain: subDomainName,
      confirmPassword,
      newPassword,
      viaVerificationOtp: location?.state?.viaVerificationOtp,
      ...(location?.state?.userIdentifier?.includes('@')
        ? { email: location?.state?.userIdentifier?.toLowerCase() }
        : { mobileNumber: location?.state?.userIdentifier || location?.state?.mobileNumber }),
    };

    if (email && confirmPassword && newPassword) {
      dispatch(emailChangePasswordNewUser(changePasswordData)).then((res) => {
        if (res?.success === "success") {
          history.push('/login');
        }
      })
      return;
    }

    if (!email && confirmPassword && newPassword) {
      dispatch(changePasswordNewUser(changePasswordData)).then((res) => {
        if (res?.success === "success") {
          history.push('/login');
        }
      })
    }
  }

  const handlePasswordChange = (event) => {
    const { name, value } = event.target;

    // Update the corresponding field in formValues
    setFormValues((prev) => {
      const updatedValues = { ...prev, [name]: value };

      // Validate newPassword strength
      const regex = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
      let errorMessage = "";
      let valid = true;

      // Check if `newPassword` meets the regex criteria
      if (!regex.test(updatedValues.newPassword)) {
        errorMessage =
          t("Password_strength_Error");
        valid = false;
      }

      // Check for password mismatch
      if (updatedValues.confirmPassword !== updatedValues.newPassword) {
        errorMessage = t("Passwords do not match.");
        valid = false;
      }

      // Update error message and button state
      if (valid) {
        document.getElementById("reset-credential-error").style.display = "none";
        document.getElementById("changeCredentialBtn").removeAttribute("disabled");
        setIsButtonDisabled(false);
      } else {
        document.getElementById("reset-credential-error").innerHTML = `<div class="errorMsg">${errorMessage}</div>`;
        document.getElementById("reset-credential-error").style.display = "block";
        document.getElementById("changeCredentialBtn").setAttribute("disabled", "disabled");
        setIsButtonDisabled(true);
      }

      return updatedValues;
    });
  };

  return (
    <Grid className="change-password-parent-div">
      <LanguageSelect />
      <Grid className="change-password-child-div">
        {isLoading && dynamicLogo && (
          <Box
            component="img"
            id="login-img-learn"
            className="change-password-logo"
            src={dynamicLogo}
            alt="Learnify"
          />
        )}
      </Grid>
      {!isOnline && (
        <Box className="form-group error-msg" style={{ display: "block" }}>
          {t("No internet connection!")}
        </Box>
      )}
      <Grid className="change-password-right-side-box">
        <Box
          id="wrapper-title"
          className="mdl-card__supporting-text input-fields"
        >
          <Box className="forget-title" style={{ color: `${bgColor}` }}>
            {t("change_password")}
          </Box>
          <Box>
            <Box component="p" className="custom-sub-title">
              {t(
                "Set a new password for your account. Use a strong combination of letters, numbers, and symbols."
              )}
            </Box>
          </Box>
          <Box className="form-group error-msg" id="reset-credential-error"></Box>
          <Box id="form-login" className="newform">
            <Box
              component="form"
              className="change-password-form"
              id="resetPasswordForm"
              onSubmit={handleSetPassword}
              method="post"
            >
              <Box className="otg otg-items-1 password-box">
                <Box
                  className="otg-item mdc-text-field mdl-js-textfield mdc-text-field--floating-label"
                  id="wrapper"
                >
                  <Input
                    name="newPassword"
                    className="input-box required_text"
                    id="newPassword"
                    type="password"
                    onChange={handlePasswordChange}
                    onKeyDown={preventSpaceKey}
                    placeholder={t("new_password")}
                  />
                  <InputLabel
                    className="mdc-text-field__label"
                    style={{ color: `${bgColor}`, padding: "2px" }}
                    htmlFor="newPassword"
                  >
                    {t("new_password")}
                  </InputLabel>
                  <Icon
                    className="fa fa-eye-slash toggle-password-icon eye-icon-align"
                    id="toggleNewPassword"
                    onClick={() =>
                      togglePasswordVisibility(
                        "newPassword",
                        "toggleNewPassword"
                      )
                    }
                  ></Icon>
                </Box>
              </Box>
              <Box className="otg otg-items-1">
                <Box
                  className="otg-item mdc-text-field mdl-js-textfield mdc-text-field--floating-label"
                  id="wrapper"
                >
                  <Input
                    name="confirmPassword"
                    className="input-box required_text"
                    id="confirmPassword"
                    type="password"
                    onChange={handlePasswordChange}
                    placeholder={t("confirm_password")}
                    onKeyDown={preventSpaceKey}
                  />
                  <InputLabel
                    className="mdc-text-field__label"
                    style={{ color: `${bgColor}`, padding: "2px" }}
                    htmlFor="confirmPassword"
                  >
                    {t("confirm_password")}
                  </InputLabel>
                  <Icon
                    className="fa fa-eye-slash toggle-password-icon eye-icon-align"
                    id="toggleConfirmPassword"
                    onClick={() =>
                      togglePasswordVisibility(
                        "confirmPassword",
                        "toggleConfirmPassword"
                      )
                    }
                  ></Icon>
                </Box>
              </Box>
              <Box
                id="wrapper-btn"
                className="otg otg-items-1 form-box text-center otg-v-30"
              >
                <Button
                  type="submit"
                  id="changeCredentialBtn"
                  className={`change-password-submit-button ${isButtonDisabled ? "disabled-btn" : ""
                    }`}
                  style={{
                    backgroundColor: `${bgColor}`,
                    color: `${textColor}`,
                  }}
                  disabled={isButtonDisabled}
                >
                  {t("Submit")}
                </Button>
                <span id="messageError"></span>
              </Box>
              <Box className="back-login">
                <Link
                  className="back-login"
                  component={RouterLink}
                  to="/login"
                  style={{ color: `${bgColor}` }}
                >
                  {t("Back to Login")}
                </Link>
              </Box>
            </Box>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ChangePassword;